// #region Global Imports
import * as React from 'react';
import cx from 'classnames';
// #endregion Global Imports
// #region Local Imports
import { gql } from '@generated/gql';
import { getFragmentData } from '@generated/fragment-masking';
import type { IProps } from '@components/Paragraphs/ParagraphMedia/Video/Video';
import styles from './Video.module.css';
// #endregion Local Imports

export const VideoFragment = gql(/* GraphQL */ `
  fragment VideoFragment on MediaRemoteVideo {
    video: fieldMediaOembedVideo
  }
`);

/* https://stackoverflow.com/questions/21607808/convert-a-youtube-video-url-to-embed-code */
function getId(url: string): string {
  const regExp =
    /^.*(?<grp1>youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)(?<grp2>[^#&?]*).*/;
  const match = regExp.exec(url);

  if (match && match[2]?.length === 11) {
    return match[2];
  }

  return 'error';
}

export const Video: React.FunctionComponent<IProps.Video> = ({
  video: _video,
}) => {
  const video = getFragmentData(VideoFragment, _video);
  return (
    <div className={cx(styles.Video__root, 'Video__root')}>
      <div className={styles.Video__wrapper}>
        <iframe
          allowFullScreen
          className={styles.Video__iframe}
          frameBorder="0"
          src={`https://www.youtube.com/embed/${getId(String(video.video))}`}
          title={'iframe-'.concat(String(video.video))}
        />
      </div>
    </div>
  );
};
